import logo from './logo.svg';
import './App.css';
import './style.css';
import './bubble.css';
import keyboard_mouse from './images/keyboard_mouse.svg'
import {observer} from "mobx-react";
import React from 'react';
import Chatroom from './chatroom'

import experimentState, {ApplicationState} from "./state/experimentState";
import themeState from "./state/themeState";
import {mouseState} from "./state/mouseState";

import $ from 'jquery';
import CalibrationBox from "./calibrationbox";
import MouseJquery from "./mouseJquery";
import Phase2Screen from "./screens/phase2Screen";
import InformedConsent from "./screens/informedConsent";
import Phase1Screen from "./screens/phase1Screen";
import {transformQuestions} from "./data/questions"
import InstructionView from "./screens/InstructionView";
import {recordEvent} from "./utils"

// var event_signups = ["keyup","keydown","mousedown","mouseup"]
var event_signups = {
    document: ["keyup", "keydown", "mousedown", "mouseup", "mousemove"], window: ["resize"]

}

event_signups["document"].forEach((el) => {
    $(document).off(el);
    $(document).on(el, recordEvent);
})
event_signups["window"].forEach((el) => {
    $(window).off(el);
    $(window).on(el, recordEvent);
})


class MouseGravity extends React.Component {
    render() {
        let xscale = 40
        let yscale = 20
        let n = 50 // Reduced for better performance with arrows
        let arr = Array.from(Array(n), (_, i) => i)
        let chat = document.getElementById('chats').getBoundingClientRect();

        return <div>
            {arr.map((x, idx) => {
                return <div key={`${x}_${idx}`}>
                    {arr.map((y, idy) => {
                        // Calculate the absolute position of this grid point
                        let abs_x = x * xscale;
                        let abs_y = y * yscale;

                        // Use this point as both origin and current position
                        // Apply a small test delta to see the transformation effect
                        let test_delta_x = 5; // Small test movement
                        let test_delta_y = 5;

                        let transform = mouseState.mouse_transforms[mouseState.mouse_transforms.length - 1];
                        let [transformed_dx, transformed_dy] = mouseState.mouseSpeedFuncs[mouseState.mouseSpeedFuncs.length - 1](
                            abs_x, abs_y, // origin
                            test_delta_x, test_delta_y, // test delta
                            abs_x, abs_y,
                            transform
                        );

                        // Calculate the difference from original delta to show effect
                        let effect_x = transformed_dx - test_delta_x;
                        let effect_y = transformed_dy - test_delta_y;

                        // Calculate arrow properties
                        let magnitude = Math.sqrt(effect_x * effect_x + effect_y * effect_y);
                        let angle = Math.atan2(effect_y, effect_x) * 180 / Math.PI;

                        // Scale arrow size based on effect magnitude
                        let arrow_size = Math.min(magnitude * 2, 20);
                        let opacity = Math.min(magnitude * 0.15, 1);
                        let color = `hsl(${angle}deg, ${magnitude * 100}%, 45%)`
                        return <div
                            key={`${x}_${y}_${idx}_${idy}`}
                            style={{
                                position: "absolute",
                                left: abs_x,
                                top: abs_y,
                                pointerEvents: "none",
                                transform: `rotate(${angle}deg)`,
                                transformOrigin: "center",
                                opacity: opacity,
                            }}
                        >
                            <div style={{
                                width: `${arrow_size}px`,
                                height: "2px",
                                backgroundColor: color,
                                position: "relative",
                            }}>
                                {/* Arrow head */}
                                <div style={{
                                    position: "absolute",
                                    right: "-3px",
                                    top: "-2px",
                                    width: "0",
                                    height: "0",
                                    borderLeft: `6px solid ${color}`,
                                    borderTop: "3px solid transparent",
                                    borderBottom: "3px solid transparent",
                                    // borderColor: color,
                                }}/>
                            </div>
                        </div>
                    })}
                </div>
            })}
        </div>
    }
}

class App extends React.Component {

    constructor(props) {
        super(props);
        this.tickRef = null;
        this.state = {
            ticker: 0,
        }
    }

    componentDidMount() {
        this.tickLoading()


        event_signups["document"].forEach((el) => {
            $(document).off(el);
            $(document).on(el, recordEvent);
        })
        event_signups["window"].forEach((el) => {
            $(window).off(el);
            $(window).on(el, recordEvent);
        })
    }

    componentWillUnmount() {
        if (this.tickRef) {
            clearTimeout(this.tickRef)
        }

        event_signups["document"].forEach((el) => {
            $(document).off(el);
            $(document).on(el, recordEvent);
        })
        event_signups["window"].forEach((el) => {
            $(window).off(el);
            $(window).on(el, recordEvent);
        })
    }

    tickLoading() {
        if (this.tickRef) {
            clearTimeout(this.tickRef)
        }
        if (experimentState.application_state === ApplicationState.APP_LOADING) {
            this.tickRef = setTimeout(this.tickLoading.bind(this), 10000)
            this.setState({ticker: this.state.ticker + 1})
        }
    }

    handleMouseApp(evt) {
        if (evt.type === "mouseenter") {
            experimentState.setApplicationState(ApplicationState.APP_MOUSE_CALIBRATION)
        } else if (evt.type === "mouseleave") {
            experimentState.setFakeMouseVisibility(false);
        }
    }

    render() {
        switch (experimentState.application_state) {
            case ApplicationState.APP_LOADING: {

                return <div>
                    <header className="header" style={{backgroundColor: themeState.colour_primary}}><h1>Experiment</h1>
                    </header>
                    <section style={{display: "flex", flexDirection: "column", gap: "16px"}}>
                        <p style={{
                            display: "flex",
                            justifyContent: "center",
                            paddingTop: "128px",
                            textAlign: "center"
                        }}>⏳ App is aan het laden...</p>
                        {(this.state.ticker >= 1) ?
                            <p style={{display: "flex", justifyContent: "center", textAlign: "center"}}>(Als dit lang
                                duurt, dan is de server waarschijnlijk offline.)</p> : null}
                        {(this.state.ticker >= 5) ?
                            <p style={{display: "flex", justifyContent: "center", textAlign: "center"}}>Als u mee wil
                                doen aan het experiment, mail dan {experimentState.myEmail()}</p> : null}

                    </section>
                </div>
            }
            case ApplicationState.APP_INFORMED_CONSENT: {
                return <InformedConsent nextState={ApplicationState.APP_INSTRUCTION_PROFILE}/>
            }
            case ApplicationState.APP_INSTRUCTION_PROFILE: {
                let welcome_text = null;
                return <div>
                    <header className="header" style={{backgroundColor: themeState.colour_primary}}><h1>Toetsenbord en
                        muis nodig!</h1></header>
                    <section style={{display: "flex", flexDirection: "column", gap: "16px"}}>
                        <div>Nogmaals bedankt voor de interesse!</div>
                        <div>Voor dit experiment heeft u een toetsenbord en een losse muis nodig.</div>
                        <div style={{fontSize: "256px", color: themeState.colour_primary, alignSelf: "center"}}><img
                            src={keyboard_mouse}/></div>
                        <div>Indien u dit niet beschikbaar hebt. Sluit dit scherm en laat het alstublieft aan de
                            experiment leider weten. Dan kan er een andere tijd ingepland worden.
                        </div>
                        <div>Indien wel beschikbaar, klik dan op de knop hieronder om verder te gaan.</div>
                        <button style={{marginTop: "16px", padding: "16px", backgroundColor: themeState.colour_primary}}
                                onClick={() => {
                                    experimentState.setApplicationState(ApplicationState.APP_PHASE_1_PRE)
                                }}>Ja ik heb een toetsenbord en een losse muis en ik wil graag verder
                        </button>
                    </section>
                </div>
            }
            case ApplicationState.APP_PHASE_1_PRE: {
                let welcome_text = null;
                return <div>
                    <header className="header" style={{backgroundColor: themeState.colour_primary}}><h1>Phase 1</h1>
                    </header>
                    <section style={{display: "flex", flexDirection: "column", gap: "16px"}}>
                        <div>Welkom bij fase 1.</div>
                        <div>Wij vragen u straks om een kleine selectie aan persoonlijke gegevens in te vullen.</div>
                        <div>Deze gegevens zijn belangrijk voor de loop van het verdere experiment en we vragen u deze
                            naar waarheid in te vullen.
                        </div>
                        <div>Zoals eerder gemeld is de opzet van het experiment zodanig dat deze gegevens NOOIT uw
                            computer verlaten. Zodra u dit scherm heeft gesloten zijn ze weg.
                        </div>
                        <div>Wij wensen u veel plezier met deze fase en de fases die hierop volgen.</div>
                        <div>Klik op de knop hieronder om verder te gaan.</div>
                        <button style={{marginTop: "16px", padding: "16px", backgroundColor: themeState.colour_primary}}
                                onClick={() => {
                                    experimentState.setApplicationState(ApplicationState.APP_PHASE_1)
                                }}>Verder
                        </button>
                    </section>
                </div>
            }
            case ApplicationState.APP_PHASE_1: {
                return <Phase1Screen nextPhase={ApplicationState.APP_PHASE_2_PRE}/>
            }
            case ApplicationState.APP_PHASE_2_PRE: {
                return <div>
                    <header className="header" style={{backgroundColor: themeState.colour_primary}}><h1>Succesvol
                        ingevuld</h1></header>
                    <section style={{display: "flex", flexDirection: "column", gap: "16px"}}>
                        <div>Dank u wel. Uw gegevens zijn succesvol ingevuld.</div>

                        <div>U kunt nu beginnen aan fase 2.</div>
                        {experimentState.experimentParams.lie ?
                            <div>Er wordt een profiel van een persoon aan u gepresenteerd waarvan verwacht wordt dat u
                                die leert.
                                <br/> We zullen hier een aantal vragen over stellen en verwachten dat u deze juist kunt
                                beantwoorden.</div>
                            :
                            <div>Nu volgt een overzicht van de informatie die u heeft ingevuld in fase 1. We zullen hier
                                een aantal vragen over stellen.</div>}
                        <div>Klik op de knop om verder te gaan.</div>
                        {/*<div>Dit zijn alle vragen:</div>*/}
                        {/*{experimentState.loaded ?*/}
                        {/*<ol>*/}
                        {/*    <li>Training</li>*/}
                        {/*    {experimentState.questions.map(([qid,rid,text,shortness,positive,cr],idx) => {return <div key={idx}>{idx} - {qid} - {cr.challenge? "With": "No"} - {(positive)? "True" : "False"}- {shortness} - {text} ->  - </div>})}*/}
                        {/*</ol> : <div>Experiment is niet geladen. Weet je zeker dat je bent verbonden?</div>}*/}
                        {/*/!*{experimentState.renderIqQuestions().map(({body,header,key, correct,answers}) => {return <div key={key}>{key} : {header} : {body} : {correct} : {answers.join(", ")}</div>})}*!/*/}

                        <button style={{marginTop: "16px", padding: "16px", backgroundColor: themeState.colour_primary}}
                                onClick={() => {
                                    experimentState.setApplicationState(ApplicationState.APP_TRAINING)
                                }}>Verder
                        </button>
                    </section>
                </div>

            }
            case ApplicationState.APP_TRAINING: {
                return <Phase2Screen onFinish={() => {
                    experimentState.setApplicationState(ApplicationState.APP_PRE_PHASE3)
                }}
                                     questions={experimentState.experimentParams.lie ? experimentState.thirdPartyQuestions : experimentState.questions}
                                     iqQuestions={experimentState.iqQuestions}/>
            }
            case ApplicationState.APP_PRE_PHASE3:
                let situation_style = {
                    marginLeft: "16px",
                    whiteSpace: "break-spaces",
                    backgroundColor: "rgba(13, 59, 102,0.1)",
                    padding: "1em",
                }
                let instructions = [
                    <div>U begint nu aan fase 3 van het experiment</div>,
                    <div>U bent voor deze fase uitgenodigd om te chatten met een interviewer in een chatbox</div>,
                    <div>De situatie die we u vragen in te beelden is alsvolgt:</div>,
                    (experimentState.experimentParams.lie) ?
                        <pre style={situation_style}>
                            U heeft voor een familievriend genaamd {experimentState.useProfile.firstname} {experimentState.useProfile.lastname} een online tentamen gemaakt.<br/><br/>

                            Uw tentamenpoging is gevlagd als verdacht en als zodanig is er een extra onderzoek ingesteld.<br/><br/>

                            U heeft dit gedaan om de echte {experimentState.useProfile.firstname} uit de brand te helpen.<br/><br/>

                            Dit is niet de bedoeling, maar ja.. nood breekt wet.<br/><br/>

                            De interviewer zal u een aantal vragen stellen in de veronderstelling dat u {experimentState.useProfile.firstname} bent.<br/><br/>

                            De bedoeling is dat u zo snel en natuurlijk mogelijk reageert op deze vragen, om te voorkomen dat de situatie verder geescaleerd wordt.
                        </pre>
                        : <pre style={situation_style}>
                            U bent net klaar met maken van een tentamen, online.

                            Uw tentamenpoging is gevlagd als verdacht en als zodanig is er een extra onderzoek ingesteld.<br/><br/>

                            Dit is natuurlijk onterecht en u snapt dan ook niet precies waarom u uitgenodigd bent voor dit chatgesprek.<br/><br/>

                            In ieder geval zal de interviewer u een aantal vragen stellen over wie u bent.
                        </pre>,
                    <div>
                        De bedoeling is dat u zo snel en natuurlijk mogelijk reageert op deze vragen, zodat
                        dit {(experimentState.experimentParams.lie) ? "\"" : ""}misverstand{(experimentState.experimentParams.lie) ? "\"" : ""} snel
                        opgelost kan worden.
                    </div>,
                    <div>
                        Er zijn een aantal kleine problemen in deze chat applicatie die onze programmeur er nog niet uit
                        heeft kunnen halen. We hopen op uw begrip in deze.
                    </div>,
                    // <div>Let op: het betreft hier een experimentele chat applicatie - onze excuses voor mogelijke problemen die optreden.</div>,
                    <div>Vanaf dit punt gaat het experiment nog ongeveer 30 minuten duren. Dus neem vooral een paar
                        minuten rust en klik op "start" zodra u er klaar voor bent</div>
                ]
                // delete messages
                if (!experimentState.experimentParams.admin) {
                    experimentState.emptyMessages()
                }
                return <InstructionView
                    instructions={instructions}
                    next_app_state={ApplicationState.APP_MOUSE_CALIBRATION}
                    header_text="Fase 3"
                    button="Start"
                />
            case ApplicationState.APP_CHAT:
            case ApplicationState.APP_MOUSE_CALIBRATION: {
                return <div className="App" style={{
                    height: "100vh",
                    cursor: experimentState.application_state === ApplicationState.APP_CHAT ? "none" : "revert"
                }} onMouseEnter={this.handleMouseApp.bind(this)} onMouseLeave={this.handleMouseApp.bind(this)}>
                    {/*<MouseCanvas ref={(mouseComponent) => {window.mouseCanvasComponent = mouseComponent}} manual="true" fun_id={mouseState.fun_id}/>*/}

                    {/*<header className="header" style={{backgroundColor:themeState.colour_primary}}><h1>Let's Chat</h1></header>*/}
                    <section
                        style={{display: experimentState.application_state === ApplicationState.APP_CHAT ? "block" : "none"}}>
                        <div id="chats"><
                            Chatroom questions={experimentState.questions}/>
                        </div>
                    </section>
                    <CalibrationBox/>
                    {themeState.display_mouse_gravity ? <MouseGravity/> : ""}
                    {/*<MouseVanilla/>*/}
                    <MouseJquery ref={(mouseComponent) => {
                        window.mouseJqueryComponent = mouseComponent
                    }}/>

                </div>;
            }
            case ApplicationState.APP_FINISH: {
                return <div>
                    <header className="header" style={{backgroundColor: themeState.colour_primary}}><h1>Einde
                        experiment</h1></header>
                    <section style={{display: "flex", flexDirection: "column", gap: "16px",}}>
                        <div>Dit is het einde van het experiment. Dank u wel voor het meedoen!</div>

                        <div>Het doel van dit experiment was om via de analyse van muisbewegingen geautomatiseerd
                            onderscheid te leren maken tussen waarheidssprekers en "leugenaars".
                        </div>

                        <div>Het experiment, zoals u gemerkt heeft, bestond vooral uit het stellen van een serie van 60
                            vragen waarin wij structureel de moeilijkheid van de vragen op verschillende manieren
                            manipuleerden. Dit is een experimentele methode geinspireerd door Monaro et. al. (2017), zie
                            link hieronder:
                        </div>

                        <div><a
                            href="https://journals.plos.org/plosone/article?id=10.1371/journal.pone.0177851">https://journals.plos.org/plosone/article?id=10.1371/journal.pone.0177851</a>
                        </div>

                        <div>Deze vragen gingen over uzelf indien u in de waarheidssprekers groep zat, en over uw
                            aangewezen profiel in het geval dat u in de leugenaarsgroep zat.
                        </div>

                        <div>We manipuleerden de moeilijkheid van de vragen, van "simpele" vragen over feitjes over uw
                            profiel tot "moeilijke" vragen waarin u de profielfeitjes moest verwerken tot een zinnig
                            antwoord. Daarnaast was er een set controle vragen die eigenlijk niet over uw profiel
                            gingen, en waar u dus in geen geval ook over hoefde te liegen. Daarnaast manipuleerden wij
                            op gezette momenten de manier waarop de muis reageerde op de bewegingen. Daarnaast vroegen
                            we u uiteraard om binnen de gestelde tijd te antwoorden met een zinnig antwoord.
                        </div>

                        <div>Dit komt allemaal voort uit de "cognitive load theory of deception" (Sporer (2016)),
                            oftewel de "mentale belasting-theorie van deceptie", dat
                            zegt dat liegen meer moeite kost dan de waarheid spreken. De manipulaties waren ervoor
                            bedoeld dat de leugenaars over een bepaalde drempel zouden gaan aan mentale belasting,
                            waardoor ze op 1 van de aspecten van het experiment _veel_ slechter, of in ieder geval heel
                            anders, gedrag zouden vertonen. Dit zou het makkelijk(er) moeten maken voor een computer om
                            het verschil te zien tussen een waarheidsspreker en een leugenaar, wellicht zelfs op basis
                            van het antwoord op 1 vraag.
                        </div>

                        <div>Verder is dit experiment helemaal geautomatiseerd uitgevoerd. Het gesprek aan het begin van
                            de fase 3 heeft u gehouden met GPT4o (ChatGPT) van OpenAI.
                        </div>

                        <div>Als u interesse hebt in verdere informatie en/of de resultaten van het experiment wilt
                            weten, stuur mij dan een mailtje op e.haasnoot@utwente.nl!
                        </div>

                        <div>Nogmaals bedankt voor het meedoen!</div>
                        <div>U kunt dit scherm nu sluiten.</div>
                    </section>
                </div>
            }
            case ApplicationState.APP_INVALID_LINK: {
                return <div>
                    <header className="header" style={{backgroundColor: "red"}}><h1>Invalid Experiment Key</h1></header>
                    {!(new URLSearchParams(window.location.search).get("uuid")) ?
                        <section>
                            <p>Hallo!</p>
                            <p>Dank voor uw interesse in dit experiment, maar u heeft een echte link nodig om mee te
                                kunnen doen.</p>
                            <p>Neem contact op met {experimentState.myEmail()}.</p>
                        </section> :
                        <section>
                            <p>Hallo!</p>
                            <p>De sleutel "{new URLSearchParams(window.location.search).get("uuid")}" is helaas niet bij
                                ons bekend.</p>
                            <p>Neem contact op met {experimentState.myEmail()}.</p>
                        </section>}
                </div>

            }
        }
    }
}

App = observer(App);

export default App;
